export const fixContentEditableStyles = (html: string) => {
  const div = document.createElement('div');
  div.innerHTML = html;

  fixContentEditableStyle(div);

  return div.innerHTML;
};

const fixContentEditableStyle = (el: HTMLElement) => {
  if (el.getAttribute('style')) {
    if (el.style.fontStyle === 'italic') {
      el.removeAttribute('style');
      el.innerHTML = `<i>${el.innerHTML}</i>`;
    }
    if (el.style.fontWeight === 'bold') {
      el.removeAttribute('style');
      el.innerHTML = `<b>${el.innerHTML}</b>`;
    }
  }

  Array.from(el.children).forEach((child: HTMLElement) => {
    fixContentEditableStyle(child);
  });
};
